import { FC, useState, useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import TableLeaderboard from "./component/Table";
import EarnersTable, { EarningsFilter } from "./component/EarnersTable";
import CustomSelect from "@/components/UI/CustomSelect/CustomSelect";

const earningsOptions: EarningsFilter[] = ["Total Earned", "Likes Earnings", "Zaps Earnings"];

const Leaderboard: FC = () => {
  const location = useLocation();

  const [tabValue, setTabValue] = useState(0);
  const [sortVariant, setSortVariant] = useState("Likes");
  const [order, setOrder] = useState("desc");
  const [filterTimeTrendingUsers, setFilterTimeTrendingUsers] = useState("1 day");
  const [earningsFilter, setEarningsFilter] = useState<EarningsFilter>("Total Earned");
  const leaderboardOptions = ["Likes", "Likes/Post"];
  const timeOptions = ["1 day", "1 week", "1 month", "1 year", "All time"];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get("type") || "Leaderboard";

    if (type === "Leaderboard") setTabValue(0);
    else if (type === "Top-100") setTabValue(1);
  }, [location.search]);

  const isEarnersTab = tabValue === 1;

  return (
    <Box>
      <Box bgcolor="white" sx={{ padding: "1.25rem 1.25rem 0" }}>
        {isEarnersTab ? (
          <Stack direction="row" alignItems="center" justifyContent="space-between" gap="1rem">
            <Typography sx={{ color: "#9DA6B0", fontWeight: 500, fontSize: "14px" }}>
              All-time earnings
            </Typography>
            <CustomSelect
              options={earningsOptions}
              selected={[earningsFilter]}
              onChange={(value) => setEarningsFilter(value[0] as EarningsFilter)}
              placeholder="Total Earned"
              width={420}
            />
          </Stack>
        ) : (
          <Stack direction="row" alignItems="center" gap="1rem">
            <CustomSelect
              placeholder="All time"
              options={timeOptions}
              selected={filterTimeTrendingUsers ? [filterTimeTrendingUsers] : []}
              onChange={(value) => setFilterTimeTrendingUsers(value[0])}
              width={474}
            />
            <CustomSelect
              options={leaderboardOptions}
              selected={[sortVariant]}
              onChange={(newSelected) => setSortVariant(newSelected[0])}
              placeholder="Sort by"
              width={474}
            />
          </Stack>
        )}
      </Box>

      {isEarnersTab ? (
        <EarnersTable earningsFilter={earningsFilter} order={order} setOrder={setOrder} />
      ) : (
        <TableLeaderboard
          tabValue={tabValue}
          sortVariant={sortVariant}
          order={order}
          setOrder={setOrder}
          filterTimeTrendingUsers={filterTimeTrendingUsers}
          setSortVariant={setSortVariant}
        />
      )}
    </Box>
  );
};

export default Leaderboard;
